import React, { useState, useEffect, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import SweetAlert from "react-bootstrap-sweetalert";
import redirectURL from "../redirectURL";
import { FaInfoCircle } from "react-icons/fa";
import "../../assets/css/inventorymanagement.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css"


const WHLaneFill = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date().toISOString().split('T')[0]);
  const [highlightedDates, setHighlightedDates] = useState([]);


  const pad2 = (n) => String(n).padStart(2, "0");
  const todayYMD = () => {
    const d = new Date();
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  };

  const closeAlert = () => setShow(false);

  const dateBlock = { display: "flex", flexDirection: "column", minWidth: 220 };
  const dateLabel = { fontSize: "13px", fontWeight: 400 };
  const dateInput = {
    padding: "7px",
    borderRadius: "5px",
    border: "1px solid #d9d9d9",
    width: "100%",
    marginBottom: "0px",
    cursor: "pointer",
  };
  const applyBtn = {
    backgroundColor: "#93385D",
    color: "#fff",
    borderRadius: "5px",
    padding: "8px 20px",
    border: "none",
    cursor: "pointer",
    marginRight: "20px",
    marginTop: "50px"
  };
  const resetBtn = {
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "5px",
    padding: "8px 20px",
    border: "1px solid #d9d9d9",
    cursor: "pointer",
  };

  const CustomHeader = (props) => {
    const tooltip = props?.column?.getColDef()?.headerTooltip || "";
    const [showMenu, setShowMenu] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    const onMenuClick = (event) => {
      props.showColumnMenu(event.currentTarget);
    };

    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
        onMouseEnter={() => setShowMenu(true)}
        onMouseLeave={() => setShowMenu(false)}
      >
        <span style={{ cursor: "default" }}>{props.displayName}</span>
        <div
          style={{ position: "relative", display: "inline-block" }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <FaInfoCircle style={{ fontSize: 18, opacity: 0.7 }} />
        </div>
        {props.enableMenu && (
          <span
            onClick={onMenuClick}
            style={{
              marginLeft: "5px",
              cursor: "pointer",
              fontSize: 14,
              opacity: showMenu ? 1 : 0,
              transition: "opacity 0.2s ease",
            }}
          >
            ☰
          </span>
        )}
      </div>
    );
  };

  const columnDefs = [
    { headerName: "Current Date", field: "date", width: 120, minWidth: 150 },
    { headerName: "Category", field: "category", width: 150, minWidth: 150 },
    { headerName: "SKU", field: "sku", width: 100, minWidth: 100 },
    { headerName: "Warehouse", field: "warehouse", width: 120, minWidth: 190 },
    { 
      headerName: "In Warehouse Stock", 
      field: "in_warehouse_stock", 
      minWidth: 150,
    
    },
    { 
      headerName: "Overall Stock", 
      field: "overall_stock", 
      minWidth: 130,
    
    },
    { 
      headerName: "Demand Plan Data(Units)", 
      field: "dp", 
      minWidth: 150,
  
    },
    { headerName: "MRP", field: "mrp", minWidth: 100 },
    { 
      headerName: "DP GMV", 
      field: "dp_gmv", 
      minWidth: 120,
      headerTooltip: "Demand Plan Data * MRP",
      headerComponent: CustomHeader,
  
    },
    { 
      headerName: "Overall Norm", 
      field: "overall_norm", 
      minWidth: 120,
    
    },
    { 
      headerName: "In Warehouse Norm", 
      field: "in_warehouse_norm", 
      minWidth: 150,
  
    },
    { 
      headerName: "In Warehouse Stock Norm Qty", 
      field: "in_warehouse_stock_norm_qty", 
      minWidth: 200,
      headerTooltip: "(DP/30) * In Warehouse Norm",
      headerComponent: CustomHeader,
     
    },
    { 
      headerName: "Overall Stock Norm Qty", 
      field: "overall_stock_norm_qty", 
      minWidth: 180,
      headerTooltip: "(DP/30) * Overall Norm",
      headerComponent: CustomHeader,
    
    },
    { 
      headerName: "LF In WH", 
      field: "lf_in_wh", 
      minWidth: 130,
      headerTooltip: "Indicates low fill rate in the warehouse. If the ratio of In Warehouse Stock to In Warehouse Stock Norm Qty is greater than 90%, it returns 1 (adequate stock); otherwise, it returns empty.",
      headerComponent: CustomHeader,
   
    },
    { 
      headerName: "LF Overall", 
      field: "lf_overall", 
      minWidth: 130,
      headerTooltip: "Indicates low fill rate overall. If the ratio of Overall Stock to Overall Stock Norm Qty is greater than 90%, it returns 1 (adequate stock); otherwise, it returns empty.",
      headerComponent: CustomHeader,
   
    },
    { 
      headerName: "New Column", 
      field: "new_col", 
      minWidth: 150,
      headerTooltip: "Checks if the 'date' is present. If a date is available, the value is 1; otherwise, it returns empty.",
      headerComponent: CustomHeader,

    
    },
  ];

  const defaultColDef = useMemo(
    () => ({ sortable: true, filter: true, resizable: true, flex: 1, minWidth: 100 }),
    []
  );

  const sideBar = useMemo(
    () => ({
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
        },
        {
          id: "filters",
          labelDefault: "Filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
        },
      ],
    }),
    []
  );

  const statusPanel = {
    statusPanels: [
      { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
      { statusPanel: "agTotalRowCountComponent", align: "center" },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" },
    ],
  };

       const getHighlightedDates = async () => {  
      try {
        const response = await redirectURL.post("inventory/getWHlaneFillDates", {});
        if (response.status === 200 && response.data.dates) {
          const dates = response.data.dates.map(dateStr => {
            try {
              return new Date(dateStr);
            } catch (e) {
              return null;
            }
          }).filter(date => date !== null);
          setHighlightedDates(dates);
        }
      } catch (error) {
        console.error("Failed to fetch highlighted dates:", error);
      }
    }

  const fetchData = async (dateStr) => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    try {
      const payload = { date: dateStr || currentDate };
      const resp = await redirectURL.post("inventory/getWHLaneFillData", payload);
      
      if (!resp || !resp.data) {
        throw new Error("No response from server");
      }

      const status = String(resp.data.status || "").toLowerCase();
      
      // Handle failure response
      if (status === "failure") {
        const msgTxt = resp.data.message ? String(resp.data.message) : "WH Lane raw data not found for this date";
        setBasicTitle(msgTxt);
        setBasicType("warning");
        setShow(true);
        setRowData([]);
        return;
      }
      
      if (status !== "success") {
        throw new Error("Invalid response status");
      }

      // Check if we have data or if it's empty
      if (!resp.data.data || resp.data.data === "") {
        setBasicTitle("No WH Lane data available for the selected date");
        setBasicType("warning");
        setShow(true);
        setRowData([]);
        return;
      }

      // Parse the data
      let stockData = [];
      if (typeof resp.data.data === "string") {
        try {
          stockData = JSON.parse(resp.data.data);
        } catch (parseError) {
          console.error("Error parsing WH Lane data:", parseError);
          throw new Error("Failed to parse WH Lane data");
        }
      } else if (Array.isArray(resp.data.data)) {
        stockData = resp.data.data;
      } else if (Array.isArray(resp.data)) {
        stockData = resp.data;
      }

      // Format date if needed
      stockData = stockData.map(item => {
        if (item.date) {
          // Convert date to readable format
          const dateObj = new Date(item.date);
          if (!isNaN(dateObj.getTime())) {
            return {
              ...item,
              date: dateObj.toLocaleDateString('en-CA') // YYYY-MM-DD format
            };
          }
        }
        return item;
      });

      setRowData(stockData);

      if (stockData.length === 0) {
        setBasicTitle("No WH Lane data available for the selected date");
        setBasicType("warning");
        setShow(true);
      }
    } catch (e) {
      const emsg = e && e.message ? e.message : "Unknown error";
      setBasicTitle("Failed to fetch WH Lane data: " + emsg);
      setBasicType("error");
      setShow(true);
      setRowData([]);
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  useEffect(() => {
    fetchData(currentDate);
  }, []);
useEffect(() => {
  getHighlightedDates();
}, []);

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          />
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <div className="col-sm-8 row" style={{ display: "flex", alignItems: "center" }}>
            {/* <div className="col-3 mt-4">
              <label htmlFor="currentDate" style={dateLabel}>Date:</label>
              <input
                type="date"
                id="currentDate"
                value={currentDate}
                onChange={(e) => setCurrentDate(e.target.value)}
                onClick={() => document.getElementById("currentDate").showPicker?.()}
                style={dateInput}
                max={todayYMD()}
              />
            </div> */}
            <div className="col-3 mt-4">
  <label htmlFor="currentDate" style={dateLabel}>Current Date:</label>
  <DatePicker
    selected={currentDate ? new Date(currentDate) : null}
    onChange={(date) => {
      const dateStr = date ? date.toISOString().split('T')[0] : '';
      setCurrentDate(dateStr);
    }}
    dateFormat="yyyy-MM-dd"
    className="form-control"
    placeholderText="Select date"
    maxDate={new Date()}
      highlightDates={highlightedDates}

    style={{
      padding: "7px",
      borderRadius: "5px",
      border: "1px solid #d9d9d9",
      width: "100%",
      marginBottom: "15px",
      cursor: "pointer"
    }}
  />
</div>

            <div className="col-6 mt-20">
              <button type="button" onClick={(e) => { e.preventDefault(); fetchData(currentDate); }} style={applyBtn}>
                Apply
              </button>

              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  const d = todayYMD();
                  setCurrentDate(d);
                  fetchData(d);
                }}
                style={resetBtn}
              >
                Reset
              </button>
            </div>
          </div>

          <div className="col-sm-12 p-0 pl-2 mt-5">
            <div className="ag-theme-alpine" style={{ height: 600, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                // pagination={true}
                sideBar={sideBar}
                statusBar={statusPanel}
                // paginationPageSize={100}
                enableRangeSelection={true}
                suppressFieldDotNotation={true}
                overlayNoRowsTemplate="No WH Lane data available"
                onGridReady={(params) => { if (params && params.api) params.api.sizeColumnsToFit(); }}
                onFirstDataRendered={(params) => { if (params && params.api) params.api.sizeColumnsToFit(); }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
    </>
  );
};

export default WHLaneFill;